// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"dkgNua","buttonBlock":"WbO4Rj","withLink":"cqtQhe","title":"Jj-AjV"};